<template>
  <v-card max-width="880" class="mx-auto py-5" flat>
    <v-card-title class="justify-center mb-2 pt-0">
      {{ initialExperiment.id ? $t("edit-experiment") : $t("new-experiment") }}
    </v-card-title>
    <v-form ref="form" class="px-5 pb-2">
      <v-row justify="space-around" class="py-0">
        <v-col cols="12" sm="" class="py-0">
          <FeildSimple
            @attrUpdate="experimentData.name = $event"
            :initialName="initialExperiment.name"
          />
        </v-col>
        <v-col cols="12" sm="" class="py-0">
          <FieldDate
            @attrUpdate="experimentData.date = $event"
            :initialDate="initialExperiment.date"
          />
        </v-col>
      </v-row>
      <v-row justify="space-around" class="py-0">
        <v-col cols="12" md="" class="py-0">
          <FieldFile
            @attrUpdate="experimentData.attachment = $event"
            :initialAttachment="initialExperiment.filename"
            :label="$t('experiment-fileupload')"
            :required="true"
            accept="text/plain"
          />
        </v-col>
        <v-col cols="12" md="" class="py-0">
          <FieldFile
            @attrUpdate="experimentData.resultsImage = $event || null"
            :initialAttachment="initialExperiment.resultsImage"
            :label="$t('experiment-image-file')"
            accept="image/*"
          />
        </v-col>
      </v-row>
      <v-row class="py-0">
        <v-col cols="12" class="py-0">
          <FieldIntervals
            @attrUpdate="experimentData.intervals = $event"
            :initialIntervals="initialExperiment.intervals"
          />
        </v-col>
      </v-row>
      <v-row justify="space-between" class="px-3">
        <v-btn
          @click="$emit('attrUpdate', false)"
          color="grey lighten-1"
          outlined
          large
          text
          >{{ $t("cancel") }}</v-btn
        >
        <v-btn @click="submit" color="indigo accent-4" dark large>{{
          initialExperiment.id ? $t("save-experiment") : $t("create-experiment")
        }}</v-btn>
      </v-row>
    </v-form>
  </v-card>
</template>

<script>
import FeildSimple from "@/components/Shared/FeildSimple";
import FieldDate from "@/components/Shared/FieldDate";
import FieldFile from "@/components/Shared/FieldFile";
import FieldIntervals from "@/components/Shared/FieldIntervals";

export default {
  name: "AddExperiment",
  components: { FeildSimple, FieldDate, FieldFile, FieldIntervals },
  props: { initialExperiment: Object },
  data: () => ({
    experimentData: {},
    menu: false,
  }),
  methods: {
    async submit() {
      if (!this.$refs.form.validate()) return null;
      if (this.initialExperiment.id) {
        await this.$store.dispatch("experiment/update", {
          id: this.initialExperiment.id,
          experimentData: this.experimentData,
        });
      } else {
        await this.$store.dispatch("experiment/create", {
          experimentData: this.experimentData,
        });
      }
      this.$emit("attrUpdate", false);
    },
  },
};
</script>
